import defaultLoading from '@/images/loading.png';
import { Toast } from 'rc-ui-lib';
import type { ToastOptions } from 'rc-ui-lib/lib/toast';
import { ReactComponent as TickSvg } from './images/circle_tick.svg';
import { ReactComponent as SignSvg } from './images/sign.svg';
import style from './index.less';

export enum VhkToastType {
  SIGN,
  SUCCESS,
  LOADING,
}

type VhkToastOptionType = ToastOptions & {
  vhkToastType?: VhkToastType;
};
const commonConfig = {
  className: style.layout,
};

const VHKToast = (params: VhkToastOptionType) => {
  const { vhkToastType } = params;
  switch (vhkToastType) {
    case VhkToastType.SIGN:
      Toast(
        Object.assign(
          commonConfig,
          {
            icon: <SignSvg className={style.icon} style={{ width: 27, height: 27 }} />,
          },
          params
        )
      );
      break;
    case VhkToastType.SUCCESS:
      Toast.success(
        Object.assign(
          commonConfig,
          {
            icon: <TickSvg className={style.icon} style={{ width: 27, height: 27 }} />,
          },
          params
        )
      );
      break;
    case VhkToastType.LOADING:
      Toast.loading({
        icon: <img src={defaultLoading} alt="defaultLoading" className="default-loading-icon" />,
        className: 'default-loading',
        forbidClick: true,
        duration: 0,
      });
      break;
    default:
      Toast(Object.assign(commonConfig, params));
      break;
  }
};

export default VHKToast;
